import {
  validateConfig,
  showBootstrapError,
  isProduction,
  isMockMode,
  type ConfigRequirement,
} from '@rtvloco/platform/env';

// Runtime config is delivered via /config.json (mounted by Helm).
// Keys below use the platform canonical names (VITE_*); getEnv() maps them
// to their camelCase form inside config.json (graphqlUrl, oidcAuthority, …).
const PRODUCTION_REQUIRED: ConfigRequirement[] = [
  { key: 'VITE_GRAPHQL_URL', description: 'GraphQL HTTP endpoint (https://...)' },
  { key: 'VITE_GRAPHQL_WS_URL', description: 'GraphQL WebSocket endpoint (wss://...)' },
  { key: 'VITE_OIDC_AUTHORITY', description: 'OIDC Authority URL (Keycloak realm endpoint)' },
];

export function validateEnv(): void {
  if (!isProduction || isMockMode) return;

  const missing = validateConfig(PRODUCTION_REQUIRED);
  if (missing.length === 0) return;

  showBootstrapError(missing, 'FLOW');

  const message = [
    '[flow] Fatal: invalid environment configuration.',
    'The following problems must be resolved before the app can start:',
    '',
    ...missing.map((e) => `  • ${e.canonicalKey}: ${e.description}`),
    '',
    'Check the Helm values file or /config.json for this deployment.',
  ].join('\n');

  throw new Error(message);
}
